module.exports = __webpack_public_path__ + "img/lr-cb66-101.c6204d96.gif";